module.exports = __webpack_public_path__ + "img/section-demo.c0efbe27.png";